import React from 'react';
import ClaimFieldsTable from './ClaimFieldsTable';
export default function RdecMergedSchemeTable(_ref) {
  let {
    claim,
    setClaim,
    calculations,
    refreshCalculations
  } = _ref;
  const rdecMergedSchemeStepsRows = [{
    text: 'Gross RDEC',
    field: {
      name: 'merged_scheme_gross_rdec'
    }
  }, {
    text: 'Step 1 - Offset against current CT liability',
    field: {
      name: null
    }
  }, {
    text: 'Amount used to pay Corporation Tax',
    field: {
      name: 'merged_scheme_amount_used_to_pay_corporation_tax'
    }
  }, {
    text: 'Amount Remaining after Step 1',
    field: {
      name: 'merged_scheme_amount_remaining_after_step_1'
    }
  }, {
    text: 'Step 2 - Reduce by Notional Tax Deduction',
    field: {
      name: null
    }
  }, {
    text: 'Notional Tax Deduction',
    field: {
      name: 'merged_scheme_national_tax_deduction'
    }
  }, {
    text: 'Amount Remaining after Step 2',
    field: {
      name: 'merged_scheme_amount_remaining_after_step_2'
    }
  }, {
    text: 'Step 3 - cap at PAYE/NIC liabilities',
    field: {
      name: null
    }
  }, {
    text: 'Relevant Expenditure on Workers (Staff)',
    field: {
      name: 'expenditure_workers_staff',
      editable: true
    }
  }, {
    text: 'Relevant Expenditure on Workers (CEPWS)',
    field: {
      name: 'expenditure_workers_cepws',
      editable: true
    }
  }, {
    text: 'PAYE/NIC Cap Amount',
    field: {
      name: 'merged_scheme_paye_nic_cap_amount'
    }
  }, {
    text: 'Amount withheld due to exceeding cap',
    field: {
      name: 'merged_scheme_amount_witheld_due_to_exceeding_cap'
    }
  }, {
    text: 'Amount Remaining after Step 3',
    field: {
      name: 'merged_scheme_amount_remaining_after_step_3'
    }
  }, {
    text: 'Step 4 - Offset against CT liability for another accounting period',
    field: {
      name: null
    }
  }, {
    text: 'Amount used to pay Corporation Tax for another period',
    field: {
      name: 'amount_used_to_pay_corporation_tax_another_period',
      editable: true
    }
  }, {
    text: 'Amount Remaining after Step 4',
    field: {
      name: 'merged_scheme_amount_remaining_after_step_4'
    }
  }, {
    text: 'Step 5 - surrender to pay CT liability of another group company',
    field: {
      name: null
    }
  }, {
    text: 'Amount used to pay Corporation Tax for another company',
    field: {
      name: 'amount_used_to_pay_corporation_tax_another_company',
      editable: true
    }
  }, {
    text: 'Amount Remaining after Step 5',
    field: {
      name: 'merged_scheme_amount_remaining_after_step_5'
    }
  }, {
    text: 'Step 6 - Offset against any other liability to HMRC',
    field: {
      name: null
    }
  }, {
    text: 'Amount used to may any other HMRC liability',
    field: {
      name: 'amount_used_to_pay_other_hmrc_liabilities',
      editable: true
    }
  }, {
    text: 'Amount Remaining after Step 6',
    field: {
      name: 'merged_scheme_amount_remaining_after_step_6'
    }
  }, {
    text: 'Step 7 - Payable cash credit',
    field: {
      name: null
    }
  }, {
    className: 'font-weight-bold',
    text: 'BENEFIT - Cash credit claimed',
    field: {
      name: 'merged_scheme_benefit_cash_credit_claimed'
    }
  }];
  return /*#__PURE__*/React.createElement(ClaimFieldsTable, {
    calculations: calculations,
    refreshCalculations: refreshCalculations,
    claim: claim,
    setClaim: setClaim,
    title: "RDEC Merged Scheme 7 Steps",
    rows: rdecMergedSchemeStepsRows
  });
}